/** @jsx h */
import { h } from 'preact'
import AboutCard from './AboutCard'
import InfiniteModal from '../../InfiniteModal'

export const AboutCardForInfiniteModal = ({ aboutTip, reveal, closeAbout }) => [
  <AboutCard {...aboutTip} revealed={reveal} coverSlideDisabled creditsSlideDisabled key='AboutCard' />,
  reveal ? <InfiniteModal.Back onClick={closeAbout()} key='InfiniteModal.Back' /> : null
]

export default AboutCardForInfiniteModal
